import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../../contexts/LanguageContext';

type Props = {
  value: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
  searchType: 'passport' | 'email';
  onSearchTypeChange: (type: 'passport' | 'email') => void;
};

export const PassportInput = ({ 
  value, 
  onChange, 
  isLoading,
  searchType,
  onSearchTypeChange
}: Props) => {
  const { translations } = useLanguage();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-2"
    >
      {/* Search Type Info */}
      <div className="flex items-center justify-between bg-yellow-50 p-3 rounded-lg">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-yellow-800">
            {translations?.passportInput?.searchByPassport || 'Search by Passport Number'}
          </span>
        </div>
        <div className="text-xs text-yellow-600 bg-yellow-100 px-2 py-1 rounded">
          {translations?.passportInput?.emailSearchSuspended || 'Email search is temporarily suspended'}
        </div>
      </div>

      {/* Label */}
      <label className="block text-sm font-medium text-gray-700">
        {translations?.passportInput?.passportLabel || 'Passport Number'}
        <span className="text-red-500 mr-1">*</span>
      </label>

      {/* Input */}
      <div className="relative">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={
            translations?.passportInput?.passportPlaceholder || 'Enter passport number'
          }
          className={`w-full px-4 py-3 border rounded-lg text-right focus:ring-2 focus:ring-primary-500 
            ${isLoading ? 'bg-gray-50 cursor-not-allowed' : ''}`}
          disabled={isLoading}
          dir="ltr"
        />

        {/* Loading Spinner */}
        {isLoading && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2">
            <div
              title={translations?.passportInput?.loading || 'Loading...'}
              className="w-4 h-4 border-2 border-primary-500 border-t-transparent rounded-full animate-spin"
            />
          </div>
        )}
      </div>
    </motion.div>
  );
};